<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    :title="headerTitle"
  >
    <slot name="title" slot="title" />
    <slot />
    <slot name="footer" slot="footer" />
  </el-dialog>
</template>

<script>
export default {
  props: {
    headerTitle: String
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  font-size: 14px;
  color: #333;

  .el-dialog__header {
    position: relative;
    height: 50px;
    line-height: 50px;
    padding: 0 12px;
    background: #f2f2f2;

    .el-dialog__title {
      font-weight: 500;
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      top: 50%;
      right: 8px;
      transform: translate3d(0, -50%, 0);
    }

    .el-icon-close {
      font-size: 22px;
      color: #999;

      &:hover {
        color: #009688;
      }
    }
  }

  .el-dialog__body {
    position: relative;
    padding: 20px 11px;
  }

  .el-dialog__footer {
    padding: 0 0 12px;
  }
}
</style>
